import { Contraparte } from "../contraparte/model";

export enum ContraparteGrupoStatus {
  ATIVO = "A",
  INATIVO = "I",
}

export interface ContraparteGrupo {
  readonly id?: number | null;
  readonly nome?: string | null;
  readonly status?: ContraparteGrupoStatus | null;
  readonly contrapartes?: Contraparte[] | null;
}
